import React from 'react';
import PropTypes from 'prop-types';
import Img from 'react-image';
import { storage } from '../../../../config';

import '.././PropertyDetailBasicInfo.css';

export function PropertyOrgLogoAndName({
  org,
}) {
  return (
    <div>
      {
        org && org.logo &&
        (
          <div>
            <Img
              src={[`${storage.cloudStoragePath}/${org.logo}`]}
              alt="Information Provided By"
              style={{ maxWidth: '130px' }}
              container={children => {
                return <div><div style={{ marginBottom: '5px' }}><small>Property Information Provided By</small></div>{children}</div>;
              }}
            />
          </div>
        )
      }
    </div>
  );
}

PropertyOrgLogoAndName.propTypes = {
  org: PropTypes.object,
};

export default PropertyOrgLogoAndName;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailBasicInfo/PropertyOrgLogoAndName/PropertyOrgLogoAndName.js